import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BusinessAccountService } from '@services/business-account.service';
import { NavigationService } from '@services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessAccountUpsellGuard implements CanActivate {
  private readonly businessAccountService = inject(BusinessAccountService);
  private readonly router = inject(Router);
  private readonly navigationService = inject(NavigationService);

  /**
   * Prevents business account orders from reaching an upsell page on sites that skip upsells for them, redirecting to
   * the next page in the flow instead.
   *
   * @param {ActivatedRouteSnapshot} _route the activated route snapshot (unused)
   * @param {RouterStateSnapshot} state the router state snapshot
   *
   * @returns {boolean | UrlTree} true to allow navigation, or a UrlTree to redirect to the next page
   */
  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.businessAccountService.shouldSkipUpsells()) {
      return this.router.createUrlTree([this.navigationService.getNextNavigationUrl(state.url)]);
    }

    return true;
  }
}
